export class PopoverData {
  public displayText: string;
  public displayValue: string | number;
  public isTitle: boolean = false;
  public ordering: number;
  public infoText?: string;
  public link: boolean = false;


  constructor(init: Partial<PopoverData> = {}) {
    Object.assign(this, init);
    if (this.displayValue !== 'null') {
      this.displayValue = this.displayValue || 'Not Available';
    }
  }

  public setDisplayText(text: string): PopoverData {
    this.displayText = text;
    return this;
  }

  public setDisplayValue(value: string | number): PopoverData {
    this.displayValue = value;
    return this;
  }

  public setTitle(isTitleRow: boolean = true):PopoverData {
    this.isTitle = isTitleRow;
    return this;
  }
}
